import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	width: 100%;

	.password-reset-form {
		.submit-button {
			margin: 2em 0;
			justify-content: flex-start;
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.register-form {
			.title {
				font-size: 1.3em;
			}
		}
	}
`;
